import React, {createContext, useEffect, useState} from 'react';
import axios from "axios";
import {config} from "../../config";

export const PortfolioContext = createContext();

export const PortfolioProvider = ({children}) => {

	const [portfolioData, setPortfolioData] = useState(null);

	useEffect(()=>{
		axios
			.get(config.domainRelPath+'/wp-json/acf/v3/options/acf-options-portfolio')
			.then( res => {
				setPortfolioData( res?.data?.acf );
			} )
			.catch(error => console.log(error));
	},[setPortfolioData]);

	return (
		<PortfolioContext.Provider value={portfolioData}>
			{portfolioData && children}
		</PortfolioContext.Provider>
	);
};

export default PortfolioContext;